<script lang="ts">
    import Icon from "@components_v2/Icon.svelte";
    import ChatReferralIcon from "@components_v2/Icons/ChatReferralIcon.svelte";
    import StatusActiveIcon from "@components_v2/Icons/StatusActiveIcon.svelte";

    import T from "@components/T.svelte";
    import TooltipActivator from "@components/Tooltip/TooltipActivator.svelte";

    import ReviewEntity from "../entities/ReviewEntity";

    export let review: ReviewEntity;
    export let namespace: string;
</script>

<div class="gw-rv-meta">
    {#if review.customer?.isVerifiedBuyer || review.customer?.isVerifiedBuyerByMerchant}
        <TooltipActivator position="bottom-start">
            <svelte:fragment>
                <div class="gw-rv-meta__icon-wrapper">
                    <Icon width="1.2em" height="1.2em">
                        <StatusActiveIcon />
                    </Icon>
                </div>
            </svelte:fragment>

            <svelte:fragment slot="content">
                {#if review.customer?.isVerifiedBuyer}
                    <T {namespace} translationKey="verified_buyer" />
                {:else if review.customer?.isVerifiedBuyerByMerchant}
                    <T {namespace} translationKey="verified_by_merchant" />
                {/if}
            </svelte:fragment>
        </TooltipActivator>
    {/if}

    {#if review.isImported}
        <TooltipActivator position="bottom-start">
            <svelte:fragment>
                <div class="gw-rv-meta__icon-wrapper">
                    <Icon width="1.2em" height="1.2em">
                        <ChatReferralIcon />
                    </Icon>
                </div>
            </svelte:fragment>

            <svelte:fragment slot="content">
                <T {namespace} translationKey="review_imported" />
            </svelte:fragment>
        </TooltipActivator>
    {/if}
</div>

<style lang="postcss">
    .gw-rv-meta {
        display: inline-flex;
        align-items: center;
        gap: 0.125em;

        &__icon-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            transition: box-shadow 0.2s ease;
            border-radius: 50%;

            &:hover {
                box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);
                background: rgba(0, 0, 0, 0.05);
            }
        }
    }
</style>
